"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption2Strong: function() {
        return _index.Caption2Strong;
    },
    caption2StrongClassNames: function() {
        return _index.caption2StrongClassNames;
    }
});
const _index = require("./components/presets/Caption2Strong/index");
